/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Plh_TitleInputs */

const vi_sl_new_plh_title = /** @type {(inputs: Sl_New_Plh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu lấy hàng lô phân loại`)
};

/**

* @param {Sl_New_Plh_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_plh_title = /** @type {((inputs?: Sl_New_Plh_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Plh_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_plh_title(inputs)
});